import { render, staticRenderFns } from "./warnconfiguration.vue?vue&type=template&id=2e2b5568&scoped=true&"
import script from "./warnconfiguration.vue?vue&type=script&lang=js&"
export * from "./warnconfiguration.vue?vue&type=script&lang=js&"
import style0 from "./warnconfiguration.vue?vue&type=style&index=0&id=2e2b5568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b5568",
  null
  
)

export default component.exports